export default {
  pagination: {},
  sales: []
};
